/**
 * Owner: Masa Bayu
 * File: format.ts
 * Date:Time: 2026-10-14 10:48
 * Description: Native QXW format · schema 1.1.0 additive · accept 1.0.0.
 */
export const QXW_SCHEMA = 'qxw';
export const QXW_FORMAT = QXW_SCHEMA;
/** Supported document identity.version values (G33 · additive). */
export const QXW_SCHEMA_VERSIONS_SUPPORTED = ['1.0.0', '1.1.0'];
/** Current write version · new documents. */
export const QXW_SCHEMA_VERSION = '1.1.0';
export function isQXWSchemaVersion(value) {
    return QXW_SCHEMA_VERSIONS_SUPPORTED.includes(value);
}
//# sourceMappingURL=format.js.map